// @flow
/* -----------------Icons--------------- */
import React from 'react';

/* -----------------UI--------------- */
import {
  CogOutline,
} from 'mdi-material-ui';

type BreadcrumbsResponse = {
  id: number,
  typ: string,
  name: string
}
type TBreadcrumbs = {
  title: string,
  link: string
}

const constructBreadcrumbs = (breadcrumbs: BreadcrumbsResponse[]) => {
  if (!breadcrumbs) {
    return [];
  }
  return breadcrumbs.map<any, any>(({
    id,
    typ,
    name,
  }) => {
    switch (typ) {
      case 'USR':
        return {
          title: name,
          link: `/user/${name}`,
        };
      case 'FLD':
        return {
          title: name,
          link: `/folder/${id}`,
        };
      case 'SST':
        return {
          title: name,
          link: `/flashcards/${id}`,
        };
      case 'QST':
        return {
          title: name,
          link: `/questions/${id}`,
        };
      default:
        return {
          title: '',
          link: '',
        };
    }
  });
};
const breadcrumbValues = (userName?: ?string) => [
  ...(userName ? [{
    title: userName,
    link: `/user/${userName}`,
  },
  ] : [{
    title: 'Dashboard',
    link: '/dashboard',
  },
  ]),
];

const breadcrumbSmartFolderValues = [
  {
    title: 'Dashboard',
    link: '/dashboard',
  },
  {
    title: '',
    link: '/dashboard',
  },
];

const profileIcons = [
  {
    title: 'Account settings',
    icon: <CogOutline />,
  },
];
export type {
  TBreadcrumbs,
  BreadcrumbsResponse,
};
export {
  breadcrumbSmartFolderValues,
  breadcrumbValues,
  profileIcons,
  constructBreadcrumbs,
};
